import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { devToolsEnabled, environment } from '../../../environments/environment';

export const devToolsGuard: CanActivateFn = () => {
  if (devToolsEnabled && !environment.production) {
    return true;
  }

  return inject(Router).createUrlTree(['/dashboard']);
};
